import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import {
  Button,
  Stack,
  TextFormField,
} from '../../../../../ui';
import { SuccessBanner } from '../SuccessBanner';
import { NewUnderlineLink } from '../NewUnderlineLink';
import LoadingDots from '../../../../../provider/checkout/TapToPayFlow/LoadingDots';
import { EmailChangeEvent } from '../contants';

type SigninStateProps = {
  emailErrorMessage: string;
  emailValue: string;
  onChangeEmail: (event: EmailChangeEvent) => void;
  onEmailFocus: () => void;
  onKeyPress: (e) => void;
  passwordValue: string;
  onChangePassword: (newValue: string) => void;
  onPasswordFocus: () => void;
  errorsComponent: JSX.Element;
  isLoading: boolean;
  onClickSignIn: () => void;
  isDisabled: boolean;
  showForgotPasswordSuccess: boolean;
  isLoadingPasswordReset: boolean;
  onClickForgotPassword: () => void;
};

export const SigninState: React.FCWithChildren<SigninStateProps> = ({
  emailErrorMessage,
  emailValue,
  onChangeEmail,
  onEmailFocus,
  onKeyPress,
  passwordValue,
  onChangePassword,
  onPasswordFocus,
  errorsComponent,
  isLoading,
  onClickSignIn,
  isDisabled,
  showForgotPasswordSuccess,
  isLoadingPasswordReset,
  onClickForgotPassword,
}) => {
  const handleChangeEmail = newValue => onChangeEmail({ newValue });

  return (
    <Stack space={16}>
      <TextFormField
        accentColor={BrandColor.Red}
        name="email"
        id="email"
        autoComplete="email"
        borderColor={BrandColor.Silver}
        style={{
          borderRadius: 4,
        }}
        message={emailErrorMessage}
        label="Email"
        aria-label="Email"
        type="email"
        value={emailValue}
        onChangeText={handleChangeEmail}
        onFocus={onEmailFocus}
        onKeyPress={onKeyPress}
        testID="booking-sign-in-and-up-email-text-field"
      />
      <TextFormField
        autoFocus
        accentColor={BrandColor.Red}
        name="password"
        id="password"
        autoComplete="password"
        borderColor={BrandColor.Silver}
        style={{
          borderRadius: 4,
        }}
        label="Password"
        aria-label="password"
        type="password"
        value={passwordValue}
        onChangeText={onChangePassword}
        onFocus={onPasswordFocus}
        onKeyPress={onKeyPress}
        testID="booking-sign-in-and-up-password-text-field"
      />
      {errorsComponent}
      <Box
        alignSelf="center"
        width="100%"
      >
        <Button
          loading={isLoading}
          appearance="primary-neue"
          size="large"
          onClick={onClickSignIn}
          testID="signin-and-signup-signin-button"
          disabled={isDisabled}
        >
          Sign In
        </Button>
      </Box>
      <Box alignItems="center" paddingBottom={8} paddingTop={4}>
        {showForgotPasswordSuccess && (
          <SuccessBanner
            successText={`Instructions to reset your password have been sent to ${emailValue}`}
          />
        )}
        {(!showForgotPasswordSuccess && !isLoadingPasswordReset) && (
          <NewUnderlineLink
            color={BrandColor.Metal}
            onPress={onClickForgotPassword}
            testID="sign-in-and-up-forgot-password-button"
          >
            Forgot password?
          </NewUnderlineLink>
        )}
        {isLoadingPasswordReset && (
          <LoadingDots
            dots={3}
            colors={[
              BrandColor.Silver,
              BrandColor.Silver,
              BrandColor.LightGrey,
              BrandColor.SuperLight,
            ]}
            size={7}
            borderRadius={16}
            bounceHeight={5}
            testIdPrefix="client-hand-phone-to-pro"
          />
        )}
      </Box>
    </Stack>
  );
};
